import CssBaseline from '@mui/material/CssBaseline';
import {Suspense} from 'react';

import {AppTopBar} from 'components/Navigate/AppTopBar/AppTopBar';
import {LeftDrawerPermanent} from 'components/Navigate/Drawers/LeftPermanent';

import {RightDrawer} from 'components/Navigate/Drawers/RightDrawer';
import ModalMenu from 'components/Navigate/ModalMenu';

import {Box, Toolbar} from '@mui/material';

import {APP_TOP_BAR_HEIGHT} from 'appConstants';
import {Loading} from 'components/Loading';
import {Outlet} from 'react-router-dom';

export const PlanLayout = () => {
  // const {pathname, state} = useParseURL();
  // const displayTable = pathname === URLPathname.overviewTable;
  // const navigationHistoryWithTable = state && state.from ? state.from.includes(URLPathname.overviewTable) : false;
  // const renderTable = navigationHistoryWithTable || displayTable;

  return (
    <Box display="flex">
      <CssBaseline />
      <AppTopBar />
      <LeftDrawerPermanent />
      <Box
        component="main"
        sx={{flexGrow: 1, height: '100vh', display: 'flex', flexDirection: 'column'}}
        overflow="auto"
      >
        <Toolbar style={{minHeight: `${APP_TOP_BAR_HEIGHT}px`}} />
        {/* {renderTable && <TableView display={displayTable} />} */}
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </Box>
      <RightDrawer />
      <ModalMenu />
    </Box>
  );
};
